var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"background-main",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"sm12":"","md8":"","lg6":""}},[_c('loginform')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }